<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>赛项评审管理</el-breadcrumb-item>
      <el-breadcrumb-item>设置评委小组</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="4" style="width: 360px !important; margin-right: 20px">
          <el-select v-model="queryInfo.MatchID" placeholder="请选择赛项名称" clearable @change="selectGettrack(queryInfo.MatchID, 0)"
                     style="width: 360px !important">
            <el-option v-for="item in matchNameoptions" :key="item.MatchID" :label="item.MatchName" :value="item.MatchID">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="8" style="margin-right:20px;">
          <el-select v-model="queryInfo.TrackID" placeholder="请选择赛道" clearable style="width: 360px !important">
            <el-option v-for="item in trackNameoptions" :key="item.TrackID" :label="item.TrackName" :value="item.TrackID">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-button icon="el-icon-search" type="primary" @click="getGroupList(1)">搜索</el-button>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="showEditCreate('add')">添加评委小组</el-button>
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="MatchName" label="赛事名称" width="280">
        </el-table-column>
        <el-table-column prop="TrackName" label="赛道名称"> </el-table-column>
        <el-table-column prop="JudgesGroupName" label="小组名称">
        </el-table-column>
        <el-table-column prop="ProfessionalField" label="专业领域" width="180">
          <template slot-scope="scope">
            <el-tag size="mini" v-for="item in scope.row.ProfessionalFields" :key="item.ProfessionalFieldID"
                    class="proftag">{{ item.ProfessionalFieldName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="JudgesList" label="评委">
          <template slot-scope="scope">
            <el-tag size="mini" v-for="item in scope.row.JudgesList" :key="item.JudgesID" class="proftag"
                    type="warning">{{ item.JudgesName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="AddTime" label="添加日期" :formatter="dataFormat">
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditCreate('edit', scope.row)">修改</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteCreate(scope.row.JudgesGroupID)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum"
                     :page-sizes="[1, 2, 5, 10]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total"
                     background>
      </el-pagination>
      <!-- 修改 -->
      <el-dialog :title="dialogTitle" :visible.sync="editDialogVisible" width="30%" @open="getJudgesSelect" @close="editresetFields">
        <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="100px">
          <el-form-item label="赛事名称" prop="MatchID">
            <el-select v-model="editForm.MatchID" placeholder="请选择" @change="selectGettrack(editForm.MatchID, 2)" style="width: 370px !important">
              <el-option v-for="item in matchNameoptions2" :key="item.MatchID" :label="item.MatchName" :value="item.MatchID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赛道名称" prop="TrackID">
            <el-select v-model="editForm.TrackID" placeholder="请选择赛道" clearable style="width: 370px !important">
              <el-option v-for="item in trackNameoptions2" :key="item.TrackID" :label="item.TrackName" :value="item.TrackID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="小组名称" prop="JudgesGroupName">
            <el-input v-model="editForm.JudgesGroupName"></el-input>
          </el-form-item>
          <el-form-item label="专业领域">
            <el-checkbox-group v-model="editForm.ProfessionalFieldArr">
              <el-checkbox v-for="(item, index) in proarr" :key="index" :label="item.ProfessionalFieldID"
                           name="profess">{{ item.ProfessionalFieldName }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="添加评委" prop="JudgesArr">
            <el-select v-model="editForm.JudgesArr" filterable multiple placeholder="请选择评委" @focus="getJudgesSelect"
                       :disabled="editForm.JudgesIsRandom === true ? true : false">
              <el-option v-for="(item, index) in judgesNameoptions" :key="index" :label="item.JudgesCode + ' ' + item.JudgesName"
                         :value="item.JudgesID">
              </el-option>
            </el-select>
            <div class="issuiji">
              <el-checkbox v-model="editForm.JudgesIsRandom" @change="emptyData">是否随机</el-checkbox>
              <el-input v-model="editForm.RandomNum" placeholder="随机评委数" size="mini" v-if="editForm.JudgesIsRandom === true"></el-input>
              <el-button size="mini" type="primary" plain v-if="editForm.JudgesIsRandom === true" @click="getRandomJudges">随机</el-button>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editCreate()">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        // 赛项名称
        MatchName: '',
        // 赛道名称
        TrackName: '',
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 10
      },
      pagedata: [],
      total: 0,
      // 修改弹框显示状态
      editDialogVisible: false,
      // 评审须知弹框显示状态
      noticeDialogVisible: false,
      // 弹窗默认标题
      dialogTitle: '',
      // 添加表单
      // JudgesIsRandom 是否随机评委
      // RandomNum 随机几个评委
      editForm: {
        MatchID: '',
        TrackID: '',
        JudgesGroupName: '',
        ProfessionalFieldArr: [],
        JudgesArr: [],
        JudgesIsRandom: false,
        RandomNum: ''
      },
      proarr: [],
      // 修改表单验证
      editRules: {
        MatchID: [
          {
            required: true,
            message: '请选择赛事名称',
            trigger: 'change'
          }
        ],
        TrackID: [
          {
            required: true,
            message: '请选择赛道名称',
            trigger: 'change'
          }
        ],
        JudgesGroupName: [
          {
            required: true,
            message: '请输入小组名称',
            trigger: 'blur'
          }
        ],
        ProfessionalFields: [
          {
            type: 'array',
            required: true,
            message: '请选择专业领域',
            trigger: 'change'
          }
        ],
        JudgesArr: [
          {
            type: 'array',
            required: true,
            message: '请选择评委',
            trigger: 'change'
          }
        ]
      },
      // 搜索赛事名称下拉选项
      matchNameoptions: [],
      // 搜索赛道下拉选项
      trackNameoptions: [],
      // 搜索下拉选择赛返回当前选中对象
      matchoObj: {},
      // 修改赛事名称下拉选项
      matchNameoptions2: [],
      // 修改赛道下拉选项
      trackNameoptions2: [],
      // 修改下拉选择赛返回当前选中对象
      matchoObj2: {},
      // 评委下拉选项
      judgesNameoptions: [],
      // 专业领域回填数组
      list: [],
      // 评委回填数组
      list1: []
    }
  },
  created() {
    //   默认获取列表
    this.getGroupList(1)
    // 默认获取赛事
    this.getAllMatch()
    // 获取专业领域
    this.getprofess()
  },
  methods: {
    //   获取赛道列表
    async getGroupList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get(
        '/api/JudgesGroup/GetJudgesGroups',
        { params: this.queryInfo }
      )
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data.judgesGroups
      this.total = res.Data.total
    },
    //   下拉获取所有赛事
    async getAllMatch() {
      const { data: res } = await this.$http.get('/api/Match/GetMatchs')
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.matchNameoptions = res.Data.matchs
      this.matchNameoptions2 = res.Data.matchs
    },
    // 下拉赛项获取对应赛道
    // selectType 0搜索 1 添加 2修改
    async selectGettrack(id, selectType) {
      const { data: res } = await this.$http.get('/api/Track/GetTracks', {
        params: { MatchID: id + 0 }
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      if (selectType === 0) {
        this.$set(this.queryInfo, 'TrackID', null)
        this.trackNameoptions = res.Data.tracks
      } else if (selectType === 2) {
        this.$set(this.editForm, 'TrackID', null)
        this.trackNameoptions2 = res.Data.tracks
      }
    },
    // 修改加载赛道
    async editSelectGettrack(id) {
      const { data: res } = await this.$http.get('/api/Track/GetTracks', {
        params: { MatchID: id + 0 }
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.trackNameoptions2 = res.Data.tracks
    },
    // 获取所有专业领域
    async getprofess() {
      const { data: res } = await this.$http.get(
        '/api/ProfessionalField/GetProfessionalFields'
      )
      this.proarr = res.Data.professionalFields
      if (res.StatusCode !== 1) return console.log(res.Msg)
    },
    // 获取所有下拉评委
    async getJudgesSelect() {
      if (this.dialogTitle === '编辑评委小组') {
        if (!this.editForm.MatchID) {
          return this.$message.error('请先选择赛事名称')
        }
      }
      const { data: res } = await this.$http.get('/api/Judges/GetJudges', {
        params: {
          MatchID: this.editForm.MatchID
        }
      })
      this.judgesNameoptions = res.Data.allJudges
      if (res.StatusCode !== 1) return console.log(res.Msg)
    },
    // 获取随机评委
    async getRandomJudges() {
      if (!this.editForm.MatchID) {
        return this.$message.error('请先选择赛事名称')
      }
      const { data: res } = await this.$http.get(
        '/api/Judges/GetAllRandomJudges',
        {
          params: {
            judgeCount: Number(this.editForm.RandomNum),
            MatchID: this.editForm.MatchID
          }
        }
      )
      this.editForm.JudgesArr = res.Data.allJudges.map((item) => item.JudgesID)
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getGroupList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage
      this.getGroupList(newPage)
    },
    // 关闭弹窗重置表单验证
    editresetFields() {
      this.editForm = {
        MatchID: '',
        TrackID: '',
        JudgesGroupName: '',
        ProfessionalFieldArr: [],
        JudgesArr: [],
        JudgesIsRandom: false
      }
      this.$refs.editFormRef.resetFields()
    },
    // 显示添加修改弹窗
    showEditCreate(type, row) {
      if (type === 'add') {
        this.dialogTitle = '添加评委小组'
      } else if (type === 'edit') {
        this.$nextTick(() => {
          // 注意看这里JudgesList JudgesID
          this.dialogTitle = '编辑评委小组'
          this.editForm = JSON.parse(JSON.stringify(row))
          this.editSelectGettrack(this.editForm.MatchID, 2)
          // 把回填过来的专业领域对象转成数组
          this.list = this.editForm.ProfessionalFields.map(
            (item) => item.ProfessionalFieldID
          )
          // 把回填过来的评委对象转成数组
          this.list1 = this.editForm.JudgesList.map((item) => item.JudgesID)
          // 转换后数组再回填到表单
          this.editForm.ProfessionalFieldArr = this.list
          this.editForm.JudgesArr = this.list1
        })
      }
      this.editDialogVisible = true
    },
    // 添加/修改
    editCreate() {
      this.$refs.editFormRef.validate(async (valid) => {
        // 验证不通过跳出
        if (!valid) return false
        // console.log(JSON.parse(JSON.stringify(this.editForm.judges)))
        // JSON.parse(JSON.stringify(this.editForm.judges)).forEach((item) => {
        //   this.obj.push({ idss: item })
        // })
        // console.log(this.obj)
        // this.editForm.judges = this.obj
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/JudgesGroup/EditJudgesGroup',
          this.editForm
        )
        // console.log(res)
        // 判断状态码
        if (res.StatusCode !== 1) return this.$message.error(res.Msg)
        // 成功提示
        this.$message.success(res.Msg)
        // 关闭弹窗
        this.editDialogVisible = false
        // 刷新列表
        this.getGroupList(this.queryInfo.pagenum)
      })
    },
    // 删除
    async deleteCreate(id) {
      // 提示是否确认删除
      const res = await this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => {
        return err
      })
      if (res !== 'confirm') return this.$message.info('已取消删除')
      const { data: resdel } = await this.$http.post(
        '/api/JudgesGroup/DeleteJudgesGroup?ids=' + id
      )
      if (resdel.StatusCode !== 1) return this.$message.error('删除失败')
      this.$message.success('删除成功')
      // 刷新列表
      this.getGroupList(this.queryInfo.pagenum)
    },
    // 勾选随机评委如果之前手动选择评委要清空
    emptyData() {
      // 勾选随机后先清空评委
      this.editForm.JudgesArr = []
    },
    // 时间格式化
    dataFormat: function (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang="less">
.total_score {
  color: #999;
  padding: 9px 0;
}
.proftag {
  margin: 0 2px;
}
.issuiji {
  width: 240px;
  display: flex;
  justify-content: space-between;
  height: 30px;
  line-height: 30px;
  margin-top: 10px;
  .el-input {
    width: 100px;
  }
}
</style>
